import { BaseBus } from "./BaseBus";
import { CommonFunctions } from "../static/common-functions";
import { DateFunctions } from "../static/date-functions";

export class InventoryCostAdjustments extends BaseBus
{
    constructor(data: InventoryCostAdjustments) {
        super(data);
    }

    CID(): any {
        return this.inventoryCostAdjustmentId;
    }
    setId(id: any) {
        this.inventoryCostAdjustmentId = id;
    }
    initialize(data: InventoryCostAdjustments) {
        super.initialize(data);
        this.insertDt = CommonFunctions.getDate(data.insertDt);
        this.updateDt = CommonFunctions.getDate(data.updateDt);
    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: any = null) {
    }
    setFromForm(data: InventoryCostAdjustments) {
        super.setFromForm(data);
        let dateNow = CommonFunctions.getDateNow();

        if (this.hasId) {
            //this.updateDt = dateNow;
            this.insertDt = data.insertDt;
            this.insertUserId = data.insertUserId;
        }
        else {
            this.insertDt = dateNow;
            this.insertUserId = data.insertUserId;
        }

    }
    setBeforeSave() {
        this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
        this.updateDt = DateFunctions.getDateTimeWithUTCOffset(this.updateDt);
    }
    setCommon(userId: any, date: Date, companyId: any = null) {
        if (!this.hasId) {
            this.insertDt = date;
            this.insertUserId = userId;
        }
        this.updateUserId = userId;
        this.updateDt = date;
    }

    inventoryCostAdjustmentId: any;
    acknowledgedYear: number;
    acknowledgedMonth: number;
    acknowledgedInventoryId: any;
    orderReceiveDetailId: any;
    quantity: number;
    reason: string;
    insertDt: Date;
    updateDt: Date;
    updateUserId: string;
    insertUserId: string;
}
